import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="om" className="py-24 md:py-32 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative aspect-[3/4] w-full max-w-md mx-auto lg:mx-0"
          >
            <img 
              src="https://images.unsplash.com/photo-1594381898411-846e7d193883?q=80&w=1974&auto=format&fit=crop" 
              alt="Diana - Personlig tränare och sjuksköterska" 
              className="w-full h-full object-cover shadow-2xl"
            />
            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-[#FAFAFA] -z-10 hidden md:block"></div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-xl"
          >
            <span className="block text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">
              Om Mig
            </span>
            <h2 className="text-3xl md:text-5xl font-medium mb-8 font-serif">
              Medicinsk kompetens & holistisk hälsa
            </h2>
            
            <div className="space-y-6 text-stone-600 font-light leading-relaxed">
              <p>
                Min passion är att hjälpa människor att må bättre, bli starkare och skapa hälsosamma vanor som håller över tid. Med en unik kombination av medicinsk kompetens och erfarenhet inom träning och kost erbjuder jag ett tryggt, personligt och evidensbaserat stöd för dig som vill investera i din hälsa.
              </p>
              <p>
                Jag är legitimerad sjuksköterska sedan 2011 och har över 13 års erfarenhet från akutsjukvården. Där har jag mött människor i några av livets mest utmanande situationer. Den erfarenheten har gett mig en djup förståelse för hur viktig hälsa, livsstil och förebyggande arbete är – och hur små förändringar kan göra stor skillnad över tid.
              </p>
              <p>
                Som personlig tränare och kostrådgivare får jag idag arbeta med det jag brinner allra mest för – att hjälpa människor att förebygga ohälsa och skapa en starkare, friskare och mer hållbar livsstil.
              </p>
            </div>
            
            <div className="mt-10 grid grid-cols-2 gap-8 border-t border-stone-200 pt-10">
              <div>
                <h4 className="text-3xl font-serif mb-2">13+</h4>
                <p className="text-xs uppercase tracking-widest text-stone-500">Års erfarenhet i sjukvården</p>
              </div>
              <div>
                <h4 className="text-3xl font-serif mb-2">100%</h4>
                <p className="text-xs uppercase tracking-widest text-stone-500">Individanpassat fokus</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;